export const toCamelCase = (s) => s
    .toLowerCase()
    .replace(/([-_][a-z0-9])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
export const toSnakeCase = (s) => s
    .replace(/([A-Z])/g, '_$1')
    .replace(/-/g, '_')
    .toLowerCase();
export const titleCase = (text = '', splitChar = ' ') => {
    return text
        .split(splitChar)
        .map(word => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word))
        .join(splitChar);
};
export function toSentenceCase(paragraph) {
    // Convert the entire paragraph to lowercase first to ensure consistency.
    paragraph = paragraph.toLowerCase();
    return paragraph.replace(/(^\s*\w{1}|\.\s*\w{1})/g, function (match) {
        // For each match found, convert it to uppercase.
        return match.toUpperCase();
    });
}
